import React = require('react');
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import AdmIcons from '../../../../../../../components/Icons/AdmIcons';

interface IQuoteDetailsView {
  id: string;
  actions: {
    push: (route: string) => void;
  };
}

const QuoteDetailsView = ({ id, actions }: IQuoteDetailsView) => {

  const handleShowQuoteDetails = () => {
    actions.push(`/account/quotes/${id}`)
  }

  return (
    <div className={'quote-details-container'} onClick={handleShowQuoteDetails}>
      <div>
        <div><b>VIEW & EDIT QUOTE</b></div>
        <div>CLICK HERE TO BUY</div>
        <div style={{ paddingTop: '10px' }}>
          <AdmIcons name={'Person'} color={'white'}/>
          <AdmIcons name={'Editing'} color={'white'}/>
          <AdmIcons name={'Destination'} color={'white'}/>
        </div>
      </div>
    </div>
  )
}

export default flow([
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        push: bindActionCreators(push, dispatch),
      }
    }),
  ),
])(QuoteDetailsView);
